import { ExclamationCircleOutlined } from '@ant-design/icons';

const APIError = ({iconType, message, showRetry}) => {

//Example showRetry
// showRetry = {
//     countDown: true,
//     countDownTime: 10, // time in seconds
//     message: "Retry", //message to display
//     custom: "<></>", //Custom HTML if any
//     refetchQuery: '' // name of query
//     refetchFunction: '' // function that will refetch
// }

const iconStyle ={
    fontSize: '14px',
    color: '#bcbcbc',
    padding: '8px'
}

const msgStyle={
    color: '#bcbcbc',
    fontSize: '14px',
    padding: '8px',
}

    return (
        <div>
            <p className={iconStyle}>
            <ExclamationCircleOutlined className={iconStyle}
                style={{fontSize: '14px', color: '#bcbcbc', padding: '8px'}}
            />
            <span className={msgStyle}
                style={{fontSize: '14px', color: '#bcbcbc', padding: '8px'}}
            >{message}</span>
            {showRetry && 
                <div>
                    <span>{showRetry?.message}</span>
                </div>
            }
            </p>
        </div>
    )
}

export default APIError;